<template>
  <header class="absolute inset-0 w-full h-[10vw] lg:z-50">
    <i
      @click="toggle"
      v-if="currentRouteName !== 'under18' && currentRouteName !== 'wait'"
      class="fa-solid fa-bars absolute text-[6vw] tablet:text-[4vw] top-[19.5vw] tablet:top-[10vw] right-[2vw] cursor-pointer laptop:hidden text-white z-50"
    ></i>
    <div class="relative px-4 mt-[4.5vw] tablet:mt-0">
      <div
        class="w-full bandeau h-[12vw] tablet:h-[8vw] laptop:h-14 absolute inset-0 top-[12vw] tablet:top-[8vw] laptop:top-[47px] desktop:top-[60px] z-10"
      ></div>
      <div
        class="max-w-8xl py-2 mx-auto relative z-40 laptop:flex items-center laptop:justify-between text-white font-semibold"
      >
        <router-link to="/wait"
          ><img
            src="@/assets/images/logo.png"
            class="w-full max-w-[35%] tablet:max-w-[19vw] laptop:max-w-[129px] desktop:max-w-[159px] m-auto laptop:m-0"
        /></router-link>
        <ul
          v-if="currentRouteName !== 'under18' && currentRouteName !== 'wait'"
          class="hidden laptop:flex items-center gap-2 uppercase tch text-lg"
        >
          <li>
            <a href="https://www.muscador.fr" target="_blank"
              >le site muscador</a
            >
          </li>
          <li>|</li>
          <li>
            <router-link to="/products">nos produits</router-link>
          </li>
        </ul>
      </div>
      <Teleport to="body">
        <Drawer @close="toggle" align="right" :closeable="true">
          <div v-if="open" class="pt-[10vw]">
            <div
              class="bg-black w-[55vw] tablet:w-[35vw] pt-[10vw] p-[5vw] rounded-tl-2xl rounded-bl-2xl text-white text-[6vw] tablet:text-[3vw] tablet:leading-[4vw] leading-[7vw] uppercase tch font-bold relative"
            >
              <img
                @click="toggle"
                src="@/assets/images/cross.png"
                class="w-[7vw] tablet:w-[4vw] absolute top-[1.7vw] left-[3vw] cursor-pointer"
              />
              <ul>
                <li class="pb-[2vw]" @click="toggle">
                  <a href="https://www.muscador.fr" target="_blank"
                    >LE SITE<br />MUSCADOR</a
                  >
                </li>
                <li class="border-b-2 border-[#F4BF03]"></li>
                <li class="pt-[2vw]" @click="toggle">
                  <router-link to="/products">nos produits</router-link>
                </li>
              </ul>
            </div>
          </div>
        </Drawer>
      </Teleport>
    </div>
  </header>
</template>
<script>
import Drawer from "vue-simple-drawer";
import Teleport from "vue2-teleport";

export default {
  name: "header-view",
  components: {
    Drawer,
    Teleport,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
<style lang="scss">
.bandeau {
  background-image: url("@/assets/images/bandeau.png");
  background-size: 100% 100%;
  background-position: bottom center;
  background-repeat: no-repeat;

  @media (max-width: 1024px) {
    background-image: none;
    background-color: #000;
  }
}
.vue-simple-drawer {
  z-index: 1000;
  background-color: transparent !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  font-family: "Teachers" !important;
}

.close-btn {
  display: none !important;
}
</style>
